import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { type IJointBillServicePeriodVoucher } from "@services/overview/types";
import { formatPrice } from "@utils/units";

interface IJointBillVoucherArchiveDisplayProps {
  totalSum?: number;
  vouchers: IJointBillServicePeriodVoucher[];
}

export const JointBillVoucherArchiveDisplay: React.FC<
  IJointBillVoucherArchiveDisplayProps
> = ({ totalSum = 0, vouchers }) => {
  const { t } = useTranslation();

  const totalAmount = vouchers[0]?.totalAmount ?? 0;

  return (
    <React.Fragment>
      <span className="text-right text-lg font-semibold">
        {t("bill.voucher.archive.paid", {
          amount: formatPrice(totalSum),
        })}
      </span>
      <span className="text-right">
        <Trans
          i18nKey="bill.voucher.archive.discount"
          values={{ amount: formatPrice(totalAmount) }}
          components={{
            b: <span className="text-lg font-semibold text-base-green" />,
          }}
        />
      </span>
    </React.Fragment>
  );
};
